<script setup lang="ts">
import BootstrapCard from '@/components/bootstrap/BootstrapCard.vue';
import SubmitButtonContent from '@/components/devextreme/SubmitButtonContent.vue';
import MfaRecoveryCodes from '@/components/MfaRecoveryCodes.vue';
import { DxButton } from 'devextreme-vue/button';
import { DxTextBox } from 'devextreme-vue/text-box';
import { ref } from 'vue';
import MfaRecoveryCodesWarning from '@/components/MfaRecoveryCodesWarning.vue';
import Routes from '@/constants/Routes';
import Icons from '@/constants/Icons';
import { useAccountService } from '@/services/api/accountService';

definePage({ name: 'AccountMfaRecoveryCodes', meta: { title: 'mfa.recoveryCodes' } });

const account = useAccountService();
const codes = ref<string[]>();
const loading = ref<boolean>(false);
const currentPassword = ref('');

async function getRecoveryCodes(): Promise<void> {
  loading.value = true;
  const response = await account.generateRecoveryCodes(currentPassword.value);
  codes.value = response?.codes ?? [];
  loading.value = false;
}
</script>

<template>
  <BootstrapCard :header-text="$t('mfa.recoveryCodes')">
    <MfaRecoveryCodesWarning>
      <p class="mt-3 mb-0">
        <i18n-t keypath="account.newCodesKeepKeys" scope="global">
          <template #link><RouterLink :to="{ name: Routes.Account.MfaReset }">{{ $t('account.resetKeysLink') }}</RouterLink></template>
        </i18n-t>
      </p>
    </MfaRecoveryCodesWarning>

    <form v-if="!codes || codes.length === 0" @submit.prevent="getRecoveryCodes">
      <DxTextBox v-model:value="currentPassword" mode="password" :label="$t('labels.currentPassword')" label-mode="floating"
          :disabled="loading" class="mt-3" />
      <DxButton type="primary" :use-submit-behavior="true" class="my-3" :disabled="loading || !currentPassword">
        <SubmitButtonContent :loading="loading" :icon="Icons.ScrewdriverWrench"
            :text="$t('mfa.generateRecoveryCodes')" />
      </DxButton>
    </form>

    <MfaRecoveryCodes v-if="codes" :codes="codes" />
  </BootstrapCard>
</template>

<style scoped>

</style>